import {fabric} from 'fabric'
fabric.Canvas.prototype.getItemByAttr = function (attr, name) {
  var object = null
  var objects = this.getObjects()
  for (var i = 0, len = this.size(); i < len; i++) {
    if (objects[i][attr] && objects[i][attr] === name) {
      object = objects[i]
      break
    }
  }
  return object
}
export const f = fabric



// WEBPACK FOOTER //
// ./uncommon-client/utilities/fabric-and-extensions.js